import { render, staticRenderFns } from "./BillingDefault.vue?vue&type=template&id=51c833aa"
import script from "./BillingDefault.vue?vue&type=script&lang=js"
export * from "./BillingDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports